export const skillInfo = [
    {
        perchant: 87,
        name: 'Residential Painting',
        pathColor: '#E30032'
    },
    {
        perchant: 84,
        name: 'Exterior Painting',
        pathColor: '#2F80CD'
    },
    {
        perchant: 89,
        name: 'Interior Painting',
        pathColor: '#8C00C6'
    },
    {
        perchant: 67,
        name: 'Others Painting',
        pathColor: '#4EBDC5'
    }
]